import { useContext } from 'react';
import { RootStoresContext } from '../../app-stores/root-store';

export const useStores = () => {
  const stores = useContext(RootStoresContext);

  if (!stores) {
    throw new Error('useStores must be used within an RootStoresProvider.');
  }

  return stores;
};
